export default __webpack_public_path__ + "6d562735557c6c93ad33a9e8bcce8f5f.png";